'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var index$6 = require('./index-ca6c0fa7.js');
var styles$w = require('./styles-2048c729.js');

var Counter = function (_a) {
    var value = _a.value, increaseHandler = _a.increaseHandler, decreaseHandler = _a.decreaseHandler, isDecreaseDisabled = _a.isDecreaseDisabled, isIncreaseDisabled = _a.isIncreaseDisabled, className = _a.className;
    return (React__default.createElement(styles$w.Container, { className: className },
        React__default.createElement(styles$w.DecreaseBlock, { className: "decrease-block", "data-testid": "decrease-block", onClick: decreaseHandler },
            React__default.createElement(styles$w.DecreaseIcon, { className: "decrease-icon", "data-testid": "decrease-icon", isDecreaseDisabled: isDecreaseDisabled, icon: index$6.faMinus, size: "1x" })),
        React__default.createElement(styles$w.CountBlock, { className: "count-block" }, value),
        React__default.createElement(styles$w.IncreaseBlock, { className: "increase-block", "data-testid": "increase-block", onClick: increaseHandler },
            React__default.createElement(styles$w.IncreaseIcon, { className: "increase-icon", "data-testid": "increase-icon", isIncreaseDisabled: isIncreaseDisabled, icon: index$6.faPlus, size: "1x" }))));
};

exports.Counter = Counter;
